import React from "react";

const PATHS = {
  rising: (
    <>
      <circle cx="16" cy="18" r="6" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M16 5v3.2M16 27.8V31M29 18h-3.2M6.2 18H3M25.5 8.5l-2.3 2.3M9.8 24.2l-2.3 2.3M25.5 27.5l-2.3-2.3M9.8 10.8 7.5 8.5"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </>
  ),
  raining: (
    <>
      <path
        d="M10 19a5.5 5.5 0 0 1 .3-11 6.5 6.5 0 0 1 12.2 2A5 5 0 0 1 22 20H10Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
      <path d="M12 23l-1.5 3M17 23l-1.5 3M22 23l-1.5 3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </>
  ),
  falling: (
    <path
      d="M16 5v22M6.5 10.5l19 11M6.5 21.5l19-11"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  ),
};

function CompassIcon({ icon, size = 28, color = "var(--gold-deep)", className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
      role="img"
      aria-hidden="true"
    >
      {PATHS[icon]}
    </svg>
  );
}

export default CompassIcon;
